/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc
 */
import * as References from './DealPlanPortalRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#getDealPlan
 */
export const GET_DEAL_PLAN_QUERY_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_getDealPlan';
export const GET_DEAL_PLAN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEAL_PLAN_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDealPlanRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#getOwnerCandidates
 */
export const GET_OWNER_CANDIDATES_QUERY_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_getOwnerCandidates';
export const GET_OWNER_CANDIDATES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OWNER_CANDIDATES_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getOwnerCandidatesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#createMilestone
 */
export const CREATE_MILESTONE_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_createMilestone';
export const CREATE_MILESTONE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MILESTONE_MUTATION_FIELD_NAME,
  args: ['dealPlanId', 'subject', 'dueDate', 'owner', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createMilestoneRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#updateMilestone
 */
export const UPDATE_MILESTONE_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_updateMilestone';
export const UPDATE_MILESTONE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_MILESTONE_MUTATION_FIELD_NAME,
  args: ['milestoneId', 'subject', 'status', 'dueDate', 'owner', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied', 'clearDueDate', 'clearAssignee'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.updateMilestoneRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#deleteMilestone
 */
export const DELETE_MILESTONE_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_deleteMilestone';
export const DELETE_MILESTONE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_MILESTONE_MUTATION_FIELD_NAME,
  args: ['milestoneId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.deleteMilestoneRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#updateDealPlan
 */
export const UPDATE_DEAL_PLAN_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_updateDealPlan';
export const UPDATE_DEAL_PLAN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_DEAL_PLAN_MUTATION_FIELD_NAME,
  args: ['name', 'description', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.updateDealPlanRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc#deleteDealPlan
 */
export const DELETE_DEAL_PLAN_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanPortalRpc_deleteDealPlan';
export const DELETE_DEAL_PLAN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_DEAL_PLAN_MUTATION_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.deleteDealPlanRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});